export interface DatabasePendingApprovalCount {
  dbName: string
  totalPendingApproval: number
}

export interface ContainerSummary {
  containerName: string
  isBlocked: boolean
  isDisabled: boolean
  totalConfigs: number
  pendingApproval: number
}

export interface FieldConfigResponse {
  id: string
  fieldPath: string
  fieldName: string
  conversionMethod: string
  approvedOn: string | null
  approvedBy: string | null
}

export interface FieldConfigUpdate {
  id: string
  conversionMethod: string
}

export interface FieldConfigSaveResponse {
  updated: number
  containerUnblocked: boolean
  anonymizationTriggered: boolean
}

export interface ContainerStatus {
  dbName: string
  containerName: string
  isBlocked: boolean
  blockedOn: string | null
  blockedReason: string | null
  isDisabled: boolean
  disabledBy: string | null
  disabledOn: string | null
  disabledReason: string | null
}

export interface ContainerAnonymizationDashboard {
  dbName: string
  containerName: string
  prodCount: number
  anonymizedCount: number
  prodTimestamp: number
  lastProcessedTimestamp: number
  isBlocked: boolean
  blockedReason: string | null
  isDisabled: boolean
  disabledBy: string | null
  disabledReason: string | null
  error: string | null
  isOrchestrationRunning: boolean
}

export interface ToggleDisabledRequest {
  isDisabled: boolean
  reason?: string
}

export interface ImportCreditAppRequest {
  referenceNumber: number
  targetEnv: string
}

export interface ContainerImportResult {
  databaseName: string
  containerName: string
  deletedCount: number
  importedCount: number
}

export interface ImportCreditAppResult {
  creditApplicationId: string
  results: ContainerImportResult[]
}

export const TARGET_ENVIRONMENTS = ['dev', 'int', 'uat'] as const

export const CONVERSION_METHODS = [
  'accountNumber',
  'apartment',
  'callbackUrl',
  'city',
  'cityToCapital',
  'civicNumber',
  'creditAppSearchEntries',
  'creditReportCacheId',
  'customerEmail',
  'deathDate',
  'equifaxUniqueNumber',
  'firstName',
  'fullName',
  'icebergAddress',
  'jsonCreditReportRawFormat',
  'lastName',
  'merchantEmail',
  'middleName',
  'noConversion',
  'numbersToFive',
  'phone',
  'postalCode',
  'sin',
  'street',
  'toAnonymizedConstant',
  'toEmptyString',
  'vin',
  'xmlEquifaxCreditReport',
] as const
